module.exports = __webpack_public_path__ + "static/markBanner-5a62ccc1a5cfb6d479806db2d4455316.png";